import Component from '@bythepixel/component-loader';

export default class YouTubePlayerWrapper extends Component {
  static loaderPriority = 'in-view'
  static selector = 'main'

  constructor(containerEl) {
    super(containerEl);
    this.init();
  }

  init() {
    if (window.hideYTActivated) return;
    let onYouTubeIframeAPIReadyCallbacks = [];

    for (let playerWrap of document.querySelectorAll(".youtube-player-wrapper")) {
      let playerFrame = playerWrap.querySelector("iframe");
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      let onPlayerStateChange = function (event) {
        if (event.data == YT.PlayerState.ENDED) {
          playerWrap.classList.add("ended");
        } else if (event.data == YT.PlayerState.PAUSED) {
          playerWrap.classList.add("paused");
        } else if (event.data == YT.PlayerState.BUFFERING) {
          playerWrap.classList.remove("ended");
          playerWrap.classList.remove("paused");
        } else if (event.data == YT.PlayerState.PLAYING) {
          setTimeout(function(){
            playerWrap.classList.remove("ended");
            playerWrap.classList.remove("paused");
          }, 250);
        }
      };

      let player;
      onYouTubeIframeAPIReadyCallbacks.push(function () {
        player = new YT.Player(playerFrame, {
          events: {
            onStateChange: onPlayerStateChange
          }
        });
      });

      playerWrap.addEventListener("click", function () {
        let playerState = player.getPlayerState();
        if (playerState == YT.PlayerState.ENDED) {
          player.seekTo(0);
        } else if (playerState == YT.PlayerState.PAUSED) {
          player.playVideo();
        }
      });

      for (let modalCloseTrigger of document.querySelectorAll('[data-comp-modal-close-trigger]')) {
        modalCloseTrigger.addEventListener('click', function () {
          player.pauseVideo();
        });
      }
    }

    window.onYouTubeIframeAPIReady = function () {
      for (let callback of onYouTubeIframeAPIReadyCallbacks) {
        callback();
      }
    };

    window.hideYTActivated = true;
  }
}
